export default {
  NO_OPTION: `Aucune option`,
  PLACEHOLDER: `Recherchez ici`
}
